import React,{useState,useEffect} from 'react'
import Box from '@mui/material/Box';
import {Typography,Button,Link} from '@mui/material';
import {makeStyles} from '@mui/styles';
import Grow from '@mui/material/Grow';
import Slide from '@mui/material/Slide';
import Collapse from '@mui/material/Collapse';
import Fade from '@mui/material/Fade';

const useStyles = makeStyles((theme)=>({
    introContainer:{
        width:'99%',
        height:'800px',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        [theme.breakpoints.down("800")]:{
            height:'700px'
          }
    }
}))
const Intro = ({refer}) => {
   
    const classes = useStyles()
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [openDrawer,setOpenDrawer] = useState(false)
    const resumeLink = "https://firebasestorage.googleapis.com/v0/b/suprith-hattikal.appspot.com/o/Suprith--Hattikal-FlowCV-Resume-20241230.pdf?alt=media&token=78702cab-a329-4785-a0c8-82e42974eecf"

    useEffect(()=>{
        
        
    },[refer])

     useEffect(() => {
       function handleResize() {
         setWindowWidth(window.innerWidth)
       }
       
       window.addEventListener('resize', handleResize)
       return () => window.removeEventListener('resize', handleResize)
     }, [])
    return (
        <div ref={refer}>
            <Box className={classes.introContainer}>
                    <Box style={{width:'80%',height:'80%'}}>
                        <Grow
                            in={true}
                            style={{ transformOrigin: '0 0 0' }}
                            {...( { timeout: 250 } )}
                        >
                            <Typography variant="h6"  style={{color:'#64ffda',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Hi,  my name is</Typography>
                        </Grow>
                        
                        

                        <Slide direction="up" in={true} mountOnEnter unmountOnExit timeout={500}>
                            <Typography variant="h1" style={{fontWeight:600,color:"#ccd6f6",fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'5px',fontSize:windowWidth>800?'6vw':'10vw'}}>Suprith Hattikal.</Typography>
                        </Slide>
                        
                        
                        <Slide direction="up" in={true} mountOnEnter unmountOnExit timeout={1000}>
                            <Typography variant="h2" style={{fontWeight:600,color:"#8892b0",fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'10px',fontSize:windowWidth>800?'4vw':'10vw'}}>Experienced Software Engineer.</Typography>
                        </Slide>
                        
                        
                        <Fade  in={true}  timeout={2000}>
                            <Box style={{maxWidth:'600px'}} >
                                <Typography variant="h6" style={{fontWeight:600,color:"#8892b0",fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",marginTop:'30px',paragraph:true,wordWrap:'break-word',fontSize:'20px'}} >{"I’m a Software Engineer with expertise in backend, frontend, full-stack development, app and web development, operating systems, and networking technologies. I am passionate about exploring cutting-edge technologies, contributing to open source, and building innovative solutions."}</Typography>
                                <Link style={{textDecoration:'none'}} href={resumeLink} target="_blank">
                                    <Button variant='text' style={{color:"#64ffda",border:'1px solid #64ffda',padding:'10px 20px 10px 20px',fontWeight:'200',marginTop:'30px',textTransform:'none'}}>Download Resume</Button>
                                </Link>
                                
                            </Box>
                        </Fade>
                        
                    </Box>

                </Box>
        </div>
    )
}

export default Intro
